/*eslint-disable*/
import { errorCode } from '@/config';
import toast from '@/utils/toast';
import * as dd from 'dingtalk-jsapi';
import qs from 'qs';
import md5 from 'md5';

/**
 * 获取具体日期方法
 * @param {*} dateString
 */
export function getWeek(dateString) {
  const dateArray = dateString.split('-');
  const date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2]);
  return `周${'日一二三四五六'.charAt(date.getDay())}`;
}

export function formatTime(second) {
  let m = Math.floor(second / 60);
  let s = second - m * 60;
  m = m < 10 ? `0${m}` : `${m}`;
  s = s < 10 ? `0${s}` : `${s}`;
  return `${m}:${s}`;
}

export function formatTimeInt(second) {
  let m = Math.round(second / 60);
  let s = second - m * 60;
  s = Math.floor(s / 100);
  m = m < 10 ? `${m}` : `${m}`;
  s = s < 10 ? `0${s}` : `${Math.floor(s)}`;
  return m;
}

export function htmlEncodeByRegExpArts(str) {
  let s = '';
  if (str.length == 0) return '';
  s = str.replace(/&nbsp;/g, ' ');
  s = s.replace(/<\/?font[^>]{0,}>/g, '');
  s = s.replace(/【high(\d)*?】/g, '');
  s = s.replace(/【\/high(\d)*?】/g, '');
  s = s.replace(/【下划线】/g, '<u>', s);
  s = s.replace(/【\/下划线】/g, '</u>', s);
  s = s.replace(/【【题干】/g, '', s);
  s = s.replace(/\/题干】/g, '', s);
  return s;
}

export function htmlEncodeByRegExp(str) {
  let s = '';
  if (str.length == 0) return '';
  s = str.replace(/&/g, '&amp;');
  s = s.replace(/</g, '&lt;');
  s = s.replace(/>/g, '&gt;');
  s = s.replace(/ /g, '&nbsp;');
  s = s.replace(/\'/g, '&#39;');
  s = s.replace(/\"/g, '&quot;');
  return s;
}
export function htmlDecodeByRegExp(str, type) {
  let s = '';
  let repNum = 0;
  if (str) {
    if (str.length === 0) return '';
    s = str.replace(/&amp;/g, '&');
    s = s.replace(/&lt;/g, ' < ');
    s = s.replace(/&gt;/g, ' > ');
    s = s.replace(/&nbsp;/g, ' ');
    s = s.replace(/<br\/>/g, '');
    s = s.replace(/<stong\/>/g, '');
    s = s.replace(/&#39;/g, "'");
    s = s.replace(/&quot;/g, '"');
    s = s.replace(/\$/g, ' $ ');
    s = s.replace(/<\/?font[^>]{0,}>/g, '');
    s = s.replace(/【high(\d)*?】/g, '');
    s = s.replace(/【\/high(\d)*?】/g, '');
    s = s.replace(/【下划线】/g, '<u>', s);
    s = s.replace(/【\/下划线】/g, '</u>', s);
    s = s.replace(/【【题干】/g, '', s);
    s = s.replace(/\/题干】/g, '', s);
    if (type) {
      // type = 1  不可编辑
      s = s.replace(/___\d___/g, (s, i) => {
        repNum++;
        return (
          // '<span id="answer_' + repNum + '" class="imitate_input"><em>___</em><i class="icon-num">'+repNum+'</i><em>___</em></span>'
          `<span id="answer_${repNum}" class="imitate_input">______</span>`
        );
      });
      s = s.replace(/\#\#\$\$\#\#/g, (s, i) => {
        repNum++;
        return (
          `<span id="answer_${repNum}" class="imitate_input">______</span>`
          // '<span id="answer_' + repNum + '" class="imitate_input"><em>______</em><i class="icon-num">'+repNum+'</i><em>___</em></span>'
        );
      });
      s = s.replace(/\|\|([0-9a-zA-Z\u4e00-\u9fa5]*)\|\|/g, (s, i) => (`<span class="paragraph-title-x">|| ${i}</span>`));
    } else {
      s = s.replace(/___\d___/g, (s, i) => {
        repNum++;
        // nothing
        // return  '<span class="fill-mark"><em>______</em><i>'+repNum+'</i></span>'
        return (
          `<span id="answer_${
            repNum
          }" class="imitate_input"contentEditable="true"  @keyup="editnameSet($event)">______</span>`
        );
      });
      s = s.replace(/\#\#\$\$\#\#/g, (s, i) => {
        repNum++;
        // return  '<span class="fill-mark"><em>______</em><i>'+repNum+'</i></span>'
        return (
          `<span id="answer_${
            repNum
          }" class="imitate_input" contentEditable="true">______</span>`
        );
      });
    }
    return s;
  }
}

export function answerFilter(answer) {
  const str = answer.replace(/<\/?[^>]*>/g, '');
  let katexHtml = str ? str.replace(/begin\{array\}\{(\*\{\d+}\{\w\}|\w)\}/ig, 'begin\{array\}')
    .replace(/begin\{array\}/ig, 'begin\{matrix\}')
    .replace(/end\{array\}/ig, 'end\{matrix\}')
    .replace(/overrightarrow&nbsp;/ig, 'overrightarrow')
    .replace(/overleftarrow&nbsp;/ig, 'overleftarrow')
    .replace(/vec&nbsp;/ig, 'vec ')
    .replace(/begin\{align\}/ig, 'begin\{aligned\}')
    .replace(/end\{align\}/ig, 'end\{aligned\}') : str;
  katexHtml = katexHtml.replace(/\$\$/ig, '')
    .replace(/\\\)/ig, '')
    .replace(/\\\(/ig, '')
    .replace(/\\\]/ig, '')
    .replace(/\\\[/ig, '')
    .replace(/&nbsp;/g, '')
    .replace(/\\rm/g, '')
    .replace(/\\\\/g, '\\\\ ');
  return katexHtml;
}

export function fillTranslate(
  str,
  inputType,
  isAnalyze,
  inputValue,
  isMultiSpaceRight,
) {
  let s = '';
  let repNum = 0;
  let html = '';
  if (str) {
    if (str.length === 0) return '';
    s = str
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, ' < ')
      .replace(/&gt;/g, ' > ')
      .replace(/&nbsp;/g, ' ')
      .replace(/<br\/>/g, '')
      .replace(/<stong\/>/g, '')
      .replace(/&#39;/g, "'")
      .replace(/&quot;/g, '"')
      .replace(/\$/g, ' $ ')
      .replace(/___\d+___/g, (s, i) => {
        repNum++;
        if (!isAnalyze) {
          if (inputType[repNum - 1] && !inputType[repNum - 1].input_type) {
            html = `<div class="JInput"><div class="textarea q-empty" data-reqNum="${repNum}" id="answer_${repNum}" contenteditable="true"></div></div>`;
          } else {
            html = `<div data-reqNum="${repNum}" id="answer${repNum}" class="divInput"></div>`;
          }
        } else if (inputValue.length) {
          html = `<div class="user-answer ${
            isMultiSpaceRight[repNum - 1] === 'OK' ? 'right' : 'error'
          }">$ ${inputValue[repNum - 1]} $</div>`;
        }

        return html;
      })
      .replace(/\#\#\$\$\#\#/g, (s, i) => {
        repNum++;
        // return  '<span class="fill-mark"><em>______</em><i>'+repNum+'</i></span>'
        return (
          `<span id="answer_${
            repNum
          }" class="imitate_input" contentEditable="true">______</span>`
        );
      });
    return s;
  }
}

export function arrSortToString(arr, sort = false) {
  let str = '';
  if (!sort) {
    arr.forEach((item) => {
      if (typeof item === 'object') {
        str += arrSortToString(item, true);
      } else {
        str += item.toString();
      }
    });
  } else {
    arr.sort().forEach((item) => {
      if (typeof item === 'object') {
        str += arrSortToString(item, true);
      } else {
        str += item.toString();
      }
    });
  }

  return str;
}
export function answerFormat(arr) {
  let str = '';
  arr.slice().forEach((item) => {
    str += `${item[0].content};`;
  });
  return str.slice(0, -1);
}

export function getQueryString(name) {
  const search = window.location.href.split('?')[1];
  if (search) {
    const params = search.split('&');
    const obj = {};

    for (let i = 0, l = params.length; i < l; i++) {
      const tmp = params[i].split('=');
      obj[tmp[0]] = tmp[1];
    }

    return obj[name] || '';
  }
  return '';
}

export function rem(win) {
  function resize() {
    let domWidth = domEle.getBoundingClientRect().width;
    if (domWidth / v > 540) {
      domWidth = 540 * v;
    }
    win.rem = domWidth / 16;
    domEle.style.fontSize = `${win.rem}px`;
  }
  let v;
  let initial_scale;
  let timeCode;
  const dom = win.document;
  var domEle = dom.documentElement;
  let viewport = dom.querySelector('meta[name="viewport"]');
  const flexible = dom.querySelector('meta[name="flexible"]');
  if (viewport) {
    var o = viewport
      .getAttribute('content')
      .match(/initial\-scale=(["']?)([\d\.]+)\1?/);
    if (o) {
      initial_scale = parseFloat(o[2]);
      v = parseInt(1 / initial_scale);
    }
  } else if (flexible) {
    var o = flexible
      .getAttribute('content')
      .match(/initial\-dpr=(["']?)([\d\.]+)\1?/);
    if (o) {
      v = parseFloat(o[2]);
      initial_scale = parseFloat((1 / v).toFixed(2));
    }
  }
  if (!v && !initial_scale) {
    const n = (win.navigator.appVersion.match(/android/gi),
    win.navigator.appVersion.match(/iphone/gi));
    v = win.devicePixelRatio;
    (v = n ? (v >= 3 ? 3 : v >= 2 ? 2 : 1) : 1), (initial_scale = 1 / v);
  }
  // 没有viewport标签的情况下
  if ((domEle.setAttribute('data-dpr', v), !viewport)) {
    if (
      ((viewport = dom.createElement('meta')),
      viewport.setAttribute('name', 'viewport'),
      viewport.setAttribute(
        'content',
        `initial-scale=${
          initial_scale
        }, maximum-scale=${
          initial_scale
        }, minimum-scale=${
          initial_scale
        }, user-scalable=no`,
      ),
      domEle.firstElementChild)
    ) {
      domEle.firstElementChild.appendChild(viewport);
    } else {
      const m = dom.createElement('div');
      m.appendChild(viewport), dom.write(m.innerHTML);
    }
  }
  win.dpr = v;
  win.addEventListener(
    'resize',
    () => {
      clearTimeout(timeCode), (timeCode = setTimeout(resize, 300));
    },
    false,
  );
  win.addEventListener(
    'pageshow',
    (b) => {
      b.persisted
        && (clearTimeout(timeCode), (timeCode = setTimeout(resize, 300)));
    },
    false,
  );
  resize();
}

export function isArray(obj) {
  if (
    Object.prototype.toString.call(obj).toLocaleLowerCase() === '[object array]'
  ) {
    return true;
  }
  return false;
}

export function isObject(obj) {
  if (
    Object.prototype.toString.call(obj).toLocaleLowerCase()
    === '[object object]'
  ) {
    return true;
  }
  return false;
}

export function isString(obj) {
  if (
    Object.prototype.toString.call(obj).toLocaleLowerCase()
    === '[object string]'
  ) {
    return true;
  }
  return false;
}

export function showErrMessage(e, msg) {
  let m = '';

  if (isObject(e)) {
    m = errorCode[e.code] ? e.msg : '网络错误';
  } else {
    m = msg;
  }

  if (typeof m !== 'undefined') {
    toast({
      type: 'success',
      message: m,
      duration: 3000,
    });
  }
  console.log(msg);
  console.log(e);
}

export function isM3u8(url) {
  return /\.m3u8$/.test(url);
}

export function getVideoSourceOption(url) {
  let sourceObj = {};
  if (isM3u8(url)) {
    sourceObj = {
      type: 'application/x-mpegURL',
    };
  } else {
    sourceObj = {
      type: 'video/mp4',
    };
  }

  return { ...sourceObj, src: url };
}

export function debounce(func, wait, immediate) {
  let timeout;

  return function () {
    const context = this;
    const args = arguments;

    if (timeout) clearTimeout(timeout);
    if (immediate) {
      // 如果已经执行过，不再执行
      const callNow = !timeout;
      timeout = setTimeout(() => {
        timeout = null;
      }, wait);
      if (callNow) func.apply(context, args);
    } else {
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    }
  };
}

export function isAndroid() {
  let res;
  if (/(Android)/i.test(navigator.userAgent)) {
    // 安卓机
    res = true;
  } else {
    res = false;
  }
  return res;
}

export function isIPhone() {
  let res;
  if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    // 安卓机
    res = true;
  } else {
    res = false;
  }
  return res;
}

export function isPkgCode(code) {
  return [8930003, 8930004, 8930005, 8930006, 8930007].includes(code);
}

// 判断设备类型
export function userAgentType() {
  const ua = navigator.userAgent;
  const isWindowsPhone = /(?:Windows Phone)/.test(ua);
  const isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
  const isAndroid = /(?:Android)/.test(ua);
  const isFireFox = /(?:Firefox)/.test(ua);
  const isChrome = /(?:Chrome|CriOS)/.test(ua);
  const isTablet = /(?:iPad|PlayBook)/.test(ua)
      || (isAndroid && !/(?:Mobile)/.test(ua))
      || (isFireFox && /(?:Tablet)/.test(ua));
  const isPhone = /(?:iPhone)/.test(ua) && !isTablet;
  const isPc = !isPhone && !isAndroid && !isSymbian;
  return {
    isTablet,
    isPhone,
    isAndroid,
    isPc,
  };
}

// 提示框 倒计时
export function countDownMessage(msg) {
  let num = 3;

  const timer = setInterval(() => {
    if (num === 0) {
      clearInterval(timer);
    }
    --num;
    $('.el-message__content').html(`${msg.pre + num + msg.next}`);
  }, 1000);
}

export function uniqueArrary(arr) {
  // 数组的去重
  const res = new Map();
  return arr.filter((a) => !res.has(a) && res.set(a, 1));
}

/*
 ** 添加移除class类
 * */
export function addClass(element, className) {
  if (!new RegExp(`(^|\\s)${className}(\\s|$)`).test(element.className)) { element.className += ` ${className}`; }
}
export function removeClass(element, className) {
  element.className = element.className.replace(
    new RegExp(`(^|\\s)${className}(?=(\\s|$))`, 'g'),
    '',
  );
}
export function getPercentTime(time) {
  const m = Math.floor(time / 60);
  const s = Math.floor(time - m * 60);
  return `${m}分${s}秒`;
}

export function getLocalTime(format, timestamp) {
  if (!timestamp) return '';
  let a;
  let ret;
  const jsdate = timestamp ? new Date(timestamp * 1000) : new Date();
  const pad = function (n, c) {
    if ((n += '').length < c) {
      return new Array(++c - n.length).join('0') + n;
    }
    return n;
  };
  const txt_weekdays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  const txt_ordin = {
    1: 'st',
    2: 'nd',
    3: 'rd',
    21: 'st',
    22: 'nd',
    23: 'rd',
    31: 'st',
  };
  const txt_months = [
    '',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  var f = {
    // Day
    d() {
      return pad(f.j(), 2);
    },
    D() {
      return f.l().substr(0, 3);
    },
    j() {
      return jsdate.getDate();
    },
    l() {
      return txt_weekdays[f.w()];
    },
    N() {
      return f.w() + 1;
    },
    S() {
      return txt_ordin[f.j()] ? txt_ordin[f.j()] : 'th';
    },
    w() {
      return jsdate.getDay();
    },
    z() {
      return ((jsdate - new Date(`${jsdate.getFullYear()}/1/1`)) / 864e5) >> 0;
    },

    // Week
    W() {
      const a = f.z();
      const b = 364 + f.L() - a;
      let nd2;
      const nd = (new Date(`${jsdate.getFullYear()}/1/1`).getDay() || 7) - 1;
      if (b <= 2 && (jsdate.getDay() || 7) - 1 <= 2 - b) {
        return 1;
      }
      if (a <= 2 && nd >= 4 && a >= 6 - nd) {
        nd2 = new Date(`${jsdate.getFullYear() - 1}/12/31`);
        return date('W', Math.round(nd2.getTime() / 1000));
      }
      return (1 + (nd <= 3 ? (a + nd) / 7 : (a - (7 - nd)) / 7)) >> 0;
    },

    // Month
    F() {
      return txt_months[f.n()];
    },
    m() {
      return pad(f.n(), 2);
    },
    M() {
      return f.F().substr(0, 3);
    },
    n() {
      return jsdate.getMonth() + 1;
    },
    t() {
      let n;
      if ((n = jsdate.getMonth() + 1) == 2) {
        return 28 + f.L();
      }
      if ((n & 1 && n < 8) || (!(n & 1) && n > 7)) {
        return 31;
      }
      return 30;
    },

    // Year
    L() {
      const y = f.Y();
      return !(y & 3) && (y % 1e2 || !(y % 4e2)) ? 1 : 0;
    },
    // o not supported yet
    Y() {
      return jsdate.getFullYear();
    },
    y() {
      return (`${jsdate.getFullYear()}`).slice(2);
    },

    // Time
    a() {
      return jsdate.getHours() > 11 ? 'pm' : 'am';
    },
    A() {
      return f.a().toUpperCase();
    },
    B() {
      // peter paul koch:
      const off = (jsdate.getTimezoneOffset() + 60) * 60;
      const theSeconds = jsdate.getHours() * 3600
        + jsdate.getMinutes() * 60
        + jsdate.getSeconds()
        + off;
      let beat = Math.floor(theSeconds / 86.4);
      if (beat > 1000) beat -= 1000;
      if (beat < 0) beat += 1000;
      if (String(beat).length == 1) beat = `00${beat}`;
      if (String(beat).length == 2) beat = `0${beat}`;
      return beat;
    },
    g() {
      return jsdate.getHours() % 12 || 12;
    },
    G() {
      return jsdate.getHours();
    },
    h() {
      return pad(f.g(), 2);
    },
    H() {
      return pad(jsdate.getHours(), 2);
    },
    i() {
      return pad(jsdate.getMinutes(), 2);
    },
    s() {
      return pad(jsdate.getSeconds(), 2);
    },
    // u not supported yet

    // Timezone
    // e not supported yet
    // I not supported yet
    O() {
      let t = pad(Math.abs((jsdate.getTimezoneOffset() / 60) * 100), 4);
      if (jsdate.getTimezoneOffset() > 0) t = `-${t}`;
      else t = `+${t}`;
      return t;
    },
    P() {
      const O = f.O();
      return `${O.substr(0, 3)}:${O.substr(3, 2)}`;
    },
    // T not supported yet
    // Z not supported yet

    // Full Date/Time
    c() {
      return (
        `${f.Y()
        }-${
          f.m()
        }-${
          f.d()
        }T${
          f.h()
        }:${
          f.i()
        }:${
          f.s()
        }${f.P()}`
      );
    },
    // r not supported yet
    U() {
      return Math.round(jsdate.getTime() / 1000);
    },
  };

  return format.replace(/[\\]?([a-zA-Z])/g, (t, s) => {
    if (t != s) {
      // escaped
      ret = s;
    } else if (f[s]) {
      // a date function exists
      ret = f[s]();
    } else {
      // nothing special
      ret = s;
    }
    return ret;
  });
}

export function userAnswerFormat(arr) {
  let str = '';
  arr.slice().forEach((item) => {
    str += `\\[ ${item.content}\\]` + ';';
  });
  return str;
}

export function ddToast(msg) {
  if (dd.env.platform !== 'notInDingTalk') {
    dd.ready(() => {
      dd.device.notification.toast({
        icon: '', // icon样式，不同客户端参数不同，请参考参数说明
        text: msg || '当前无网络，请检查后重试！', // 提示信息
        duration: 2, // 显示持续时间，单位秒，默认按系统规范[android只有两种(<=2s >2s)]
        delay: 1, // 延迟显示，单位秒，默认0
        onSuccess(result) {
          /* {} */
        },
        onFail(err) {},
      });
    });
  } else {
    toast({
      type: 'error',
      message: msg || '当前无网络，请检查后重试！',
    });
  }
}

export function getCurrentTime() {
  const myDate = new Date();
  const year = myDate.getFullYear();
  let month = myDate.getMonth() + 1;
  let date = myDate.getDate();
  let hours = myDate.getHours();
  let minutes = myDate.getMinutes();
  let seconds = myDate.getSeconds();

  month = month < 10 ? `0${month}` : month;
  date = date < 10 ? `0${date}` : date;
  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  seconds = seconds < 10 ? `0${seconds}` : seconds;

  return (
    `${year
    }-${
      month
    }-${
      date
    } ${
      hours
    }:${
      minutes
    }:${
      seconds}`
  );
}
// 过滤掉没有值的数据
// 因为值为 undefined 时，不会出现在请求中
export function getSign(info, secretKey = 'jkDD16r8wbfPU5I1') {
  const sortedKeys = Object.keys(info).filter((key) => info[key] !== undefined).sort();
  const pairs = [];
  for (let i = 0; i < sortedKeys.length; i++) {
    const key = sortedKeys[i];
    pairs.push(`${key}=${info[key]}`);
  }
  let str = pairs.join('&');
  str += `${secretKey}`;
  console.log('str', str);
  console.log('md5', md5(str).toLowerCase());
  return md5(str).toLowerCase();
}

export function getGioVariable(options) {
  const str = localStorage.getItem('UserInfo') || '{}';
  const userLocalData = JSON.parse(str);
  const {
    corpId,
    classId,
    ddTeacherId,
    hwId,
    hwName,
    ddStudentId,
    realName,
    accountId,
    userId,
    hwType,
    subjectId,
    subjectName,
    lessonId = 0,
    lessonName = '',
    courseId,
    courseName,
    questionCnt,
    tagCodeCnt,
    hwGrade,
    bvName,
  } = userLocalData;
  const hwTypeMap = {
    1: 'AT',
    2: 'MT',
    3: 'AMT',
    4: 'SAT',
  };
  const id = localStorage.getItem('usedType');
  return {

    grade: hwGrade,
    version: bvName,
    corpId,
    classId,
    ddTeacherId,
    hwId,
    hwName,
    ddStudentId,
    realName,
    accountId,
    userId,
    subjectId,
    subjectName,
    lessonId,
    lessonName: lessonName || '',
    courseId,
    courseName,
    questionCnt,
    tagCodeCnt,
    hwType: hwTypeMap[hwType] || 'MT',
    st_hwuse_id: id || 1,
    ...options,
  };
}

export function getModuleName(goalType, status) {
  const moduleNameMap = {
    STUDY: status === 4 ? '压轴题' : '学习',
    ASSESSMENT: '测试',
  };
  return moduleNameMap[goalType];
}

// 判断是钉钉环境(Android\iOS\客户端)或手机端
export function isDingOrMobi() {
  const ua = navigator.userAgent;
  return (
    ua.indexOf('DingTalk') > 0
    || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
  );
}
// 下划线转换驼峰
export function toHump(name) {
  return name.replace(/_(\w)/g, (all, letter) => letter.toUpperCase());
}
// 驼峰转换下划线
export function toLine(name) {
  return name.replace(/([A-Z])/g, '_$1').toLowerCase();
}

// 暑期练习教师端埋点
export function summerGioPoint(event, options) {
  // console.log('options='+JSON.stringify(options))
  gio('track', event, options);
}

// 查看练习gio
export function summerGioDtHw(options) {
  const hwTypeMap = {
    1: 'AT',
    2: 'MT',
    3: 'AMT',
    4: 'SAT',
  };
  return {

    corpId: '',
    classId: '',
    ddTeacherId: '',
    hwType: hwTypeMap[options.hwType] || 'SAT',
    hwId: '',
    subjectId: '',
    subjectName: '',
    version: '',
    grade: '',
    courseId: '',
    courseName: '',
    lessonId: '',
    lessonName: '',
    hwName: '',
    ...options,
  };
}

// 获取学科名称
export function getSubjectName(subjectId = 2) {
  const subjectList = [
    { subjectId: 1, subjectName: '英语' },
    { subjectId: 2, subjectName: '数学' },
    { subjectId: 3, subjectName: '语文' },
    { subjectId: 4, subjectName: '物理' },
    { subjectId: 5, subjectName: '化学' },
    // {subjectId: 6, subjectName: '生物'},
  ];
  let subjectName = '';
  subjectList.map((item) => {
    if (item.subjectId == subjectId) {
      subjectName = item.subjectName;
    }
  });
  return subjectName;
}

// 区分文理科
export function isArts(sId) {
  return sId == 1 || sId == 3;
}

// 数字转文字
export function convertToChinaNum(num) {
  const arr1 = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
  const arr2 = new Array('', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿');// 可继续追加更高位转换值
  if (!num || isNaN(num)) {
    return '零';
  }
  const english = num.toString().split('');
  let result = '';
  for (let i = 0; i < english.length; i++) {
    const des_i = english.length - 1 - i;// 倒序排列设值
    result = arr2[i] + result;
    const arr1_index = english[des_i];
    result = arr1[arr1_index] + result;
  }
  // 将【零千、零百】换成【零】 【十零】换成【十】
  result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
  // 合并中间多个零为一个零
  result = result.replace(/零+/g, '零');
  // 将【零亿】换成【亿】【零万】换成【万】
  result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
  // 将【亿万】换成【亿】
  result = result.replace(/亿万/g, '亿');
  // 移除末尾的零
  result = result.replace(/零+$/, '');
  // 将【零一十】换成【零十】
  // result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
  // 将【一十】换成【十】
  result = result.replace(/^一十/g, '十');
  return result;
}

export function isNumber(val) {
  const regPos = /^\d+(\.\d+)?$/; // 非负浮点数
  const regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; // 负浮点数
  if (regPos.test(val) || regNeg.test(val)) {
    return true;
  }
  return false;
}

export function getMonthDate(value) {
  value = new Date(value * 1000);
  const month = value.getMonth() + 1;
  const date = value.getDate();
  return `${month}月${date}日`;
}

export function getUrlKey(name) {
  return decodeURIComponent((new RegExp(`[?|&]${name}=` + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
}
export function formatDateTime(ms) {
  if (!ms) {
    return '-- -- ';
  }
  let date;
  if (!Number(ms)) {
    // date = new Date(ms);
    // 直接取字符串
    return ms.substring(5, 16);
  }
  date = new Date(ms * 1000);

  const month = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const h = String(date.getHours()).padStart(2, '0');
  const m = String(date.getMinutes()).padStart(2, '0');
  return `${month}-${d} ${h}:${m}`;
}

export function chineseToNumber(section) {
  const chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  const chnUnitSection = ['', '万', '亿', '万亿', '亿亿'];
  const chnUnitChar = ['', '十', '百', '千'];
  const curVal = section;
  let strIns = ''; let chnStr = '';
  let unitPos = 0;
  let zero = true;
  while (section > 0) {
    const v = section % 10;
    if (v === 0) {
      if (!zero) {
        zero = true;
        chnStr = section == 10 ? '十' : chnNumChar[v] + chnStr;
      }
    } else {
      zero = false;
      if (curVal < 20 && curVal >= 10) {
        if (curVal == 10) {
          chnStr = chnUnitChar[unitPos];
        } else {
          strIns = chnUnitChar[unitPos];
          chnStr = strIns + chnNumChar[v];
        }
      } else {
        strIns = chnNumChar[v];
        strIns += chnUnitChar[unitPos];
        chnStr = strIns + chnStr;
      }
    }
    unitPos++;
    section = Math.floor(section / 10);
  }
  return chnStr;
}

export function hightWords(details, qContent) {
  const smallScore = [];
  const midScore = [];
  const bigScore = [];
  details.forEach((item) => {
    if (item.score < 60) {
      smallScore.push(item.char);
    } else if (item.score >= 60 && item.score < 85) {
      midScore.push(item.char);
    } else {
      bigScore.push(item.char);
    }
  });
  let word = qContent;
  // word = word.replace(/<\/?[^>]*>/g,''); //去除HTML tag
  word = word.replace(/[ | ]*\n/g, '\n'); // 去除行尾空白
  word = word.replace(/&nbsp;/ig, '');// 去掉&nbsp;
  smallScore.sort((a, b) => b.length - a.length);
  midScore.sort((a, b) => b.length - a.length);
  bigScore.sort((a, b) => b.length - a.length);
  for (let i = 0; i < smallScore.length; i++) {
    // 文章中可能出现字母，比如出现 a， 则 span 中的 a 标签也会被替换
    if (/[a-zA-Z]/.test(smallScore[i])) {
      continue;
    }
    word = word.replace(new RegExp(smallScore[i], 'g'), `<span class='duan bad'>${smallScore[i]}</span>`);
  }
  for (let i = 0; i < midScore.length; i++) {
    if (/[a-zA-Z]/.test(midScore[i])) {
      continue;
    }
    word = word.replace(new RegExp(midScore[i], 'g'), `<span class='duan normal'>${midScore[i]}</span>`);
  }
  for (let i = 0; i < bigScore.length; i++) {
    if (/[a-zA-Z]/.test(bigScore[i])) {
      continue;
    }
    word = word.replace(new RegExp(bigScore[i], 'g'), `<span class='duan good'>${bigScore[i]}</span>`);
  }
  // console.log(word)
  return word;
}
export function formatSeconds(totalWords, grade) { // 文字数计算跟读分钟
  let coefficient = 1.2;
  Number(grade) < 3 ? coefficient = 2 : '';
  const result = totalWords * coefficient;
  return Math.floor((result / 60)) < 3 ? 3 : Math.floor((result / 60));
}

export function sort_ASCII(obj) {
  const arr = new Array();
  let num = 0;
  for (const i in obj) {
    arr[num] = i;
    num++;
  }
  const sortArr = arr.sort();
  const sortObj = {};
  for (const i in sortArr) {
    sortObj[sortArr[i]] = obj[sortArr[i]];
  }
  return qs.stringify(sortObj, {
    encode: false,
  });
}
export function randomNum(minNum, maxNum) {
  switch (arguments.length) {
    case 1:
      return parseInt(Math.random() * minNum + 1, 10);
    case 2:
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
    default:
      return 0;
  }
}
